module.exports = __webpack_public_path__ + "static/media/vice-captain-chip.9ab77b0c.png";